'use client';
import { RedirectType } from 'next/dist/client/components/redirect';
import { notFound, redirect } from 'next/navigation';
import QuizBody from 'src/components/quiz';
import { Routes } from 'src/lib/constants';
import { Screen } from 'src/lib/flows/screens';
import { isStepAllowed } from 'src/redux/actions/flow';
import { useAppDispatch } from 'src/redux/hooks';
import { setCurrentStep } from 'src/redux/reducers/form';

const isScreenName = (x: string): x is Screen => {
  return x in Screen;
};

type StepProps = {
  params: { step: string };
};

export default function Page({ params: { step } }: StepProps) {
  const dispatch = useAppDispatch();

  if (!isScreenName(step)) {
    return notFound();
  }

  if (!dispatch(isStepAllowed(step)))
    return redirect(`${Routes.Flow}`, RedirectType.replace);

  dispatch(setCurrentStep(step));

  return <QuizBody screenName={step} />;
}
